import { Button, Drawer, Grid, TextField } from '@material-ui/core';
import React, { useState } from 'react';

import { ICreativeValidation, updateCreativeValidation } from '~/src/dash/api/creative-validation';
import { ICreativeValidationRowData } from '~/src/dash/components/list-table';

export interface INotesDrawerProps {
  openDrawer: boolean;
  handleClose: () => void;
  creativeData: ICreativeValidationRowData;
  handleRefreshNotes: (rowData: ICreativeValidationRowData) => void;
}

export default function NotesDrawer({
  openDrawer,
  handleClose,
  creativeData,
  handleRefreshNotes,
}: INotesDrawerProps) {
  const [currentNote, setCurrentNote] = useState('');

  // update creative validation
  const handleNoteSave = () => {
    updateCreativeValidation(creativeData.PublisherID.toString(), {
      OriginalCreativeURL: creativeData.OriginalCreativeURL,
      CreativeURL: creativeData.CreativeURL,
      Adomain: creativeData.Adomain,
      IABCategory: creativeData.IABCategoryCodes,
      ReviewStatus: creativeData.ReviewStatus,
      Notes: currentNote,
    } as Partial<ICreativeValidation>).then(() => handleRefreshNotes(creativeData));
  };

  return (
    <Drawer anchor='right' open={openDrawer} onClose={handleClose}>
      <Grid style={{ borderBottom: '1px solid #e3e3e3', height: 40 }}>
        <Button onClick={handleClose} style={{ textTransform: 'capitalize' }}>
          Close
        </Button>
      </Grid>
      <Grid
        container
        direction='row'
        justify='flex-start'
        alignItems='center'
        style={{ paddingLeft: 20 }}
      >
        <Grid>
          <svg
            width='25'
            height='25'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M19 5V14H14V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H15L21 15V5C21 3.9 20.1 3 19 3ZM12 14H7V12H12V14ZM17 10H7V8H17V10Z'
              fill='#646464'
            />
          </svg>
        </Grid>
        <Grid style={{ marginLeft: 10, marginBottom: 3 }}>
          <h1 style={{ fontSize: 17, color: 'rgb(41, 47, 54)', fontWeight: 500 }}>Notes</h1>
        </Grid>
      </Grid>
      <Grid style={{ paddingLeft: 55 }}>
        <TextField
          style={{
            width: 500,
            height: 158,
            backgroundColor: '#f7f9fc',
            borderRadius: 4,
            marginRight: 50,
            padding: '10px 0px 0px 5px',
            marginBottom: 5,
          }}
          fullWidth
          multiline={true}
          rows={7}
          placeholder='Type your notes here...'
          defaultValue={creativeData.Notes}
          onChange={(event) => {
            setCurrentNote(event.currentTarget.value);
          }}
        />
      </Grid>
      <Grid style={{ paddingLeft: 55 }}>
        <Button
          style={{ color: 'rgb(73, 82, 255)', textTransform: 'capitalize' }}
          onClick={handleNoteSave}
        >
          Add Note
        </Button>
      </Grid>
    </Drawer>
  );
}
